// extracted by mini-css-extract-plugin
export default {"EscondeScrollBar":"estilo_EscondeScrollBar__o-c4j"};